import styled from 'styled-components'

export default styled.section`
  @media screen and (min-width: 769px) {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &.iframe {
    @media screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }

  .map-container {
    position: relative;
    width: 100%;
    /* Floor so the map is never 0-height when the flex chain above doesn't
       resolve to a definite height (e.g. inside the iframe / webviews). */
    min-height: 200px;
    overflow: hidden;

    @media screen and (min-width: 769px) {
      flex: 1;
      max-height: none;
    }

    /* Fill the container via absolute positioning instead of a height: 100%
       chain, which collapses against a flex-sized (computed 'auto') parent.
       Banners keep their existing absolute overlay (.banner, z-index: 10). */
    .map {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }

  &.iframe .map-container {
    @media screen and (max-width: 768px) {
      flex: 1;
    }
  }

  .details {
    padding: 8px 0px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    &-container {
      display: flex;
      flex-direction: column;
      gap: 16px;

      &.iframe {
        flex-direction: row;
      }

      .spacer {
        display: none;
      }
    }
    
    .message {
      margin-top: 5px;
      font-style: italic;
      color: #88001d;
    }

    .detail-row {
      width: calc(100% - 64px);
      border: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      padding: 32px;
      border-radius: 5px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      &:first-of-type {
        margin-top: 0;
      }

      &.iframe {
        > div {
          display: flex;
          flex-direction: row;
          gap: 20px; 
        }
      }
    }

    .top-details {
      width: 100%;
      display: flex;
      flex-direction: column;

      .stops {
        width: 100%;

        .service-info {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .info {
            display: flex;
            align-items: center;
            gap: 8px;
          }
          .direction-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 4px;
            width: max-content;

            img {
              width: 24px;
              height: 24px;

              &.return {
                rotate: 180deg;
              }
            }
          }
          span {
            font-size: 18px;
            font-weight: 700;
          }
          .tag-text {
            font-size: 14px;
          }
        }
      }

      .info-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .information {
          display: flex;
          flex-direction: row;
          gap: 20px;
        
          .info-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 16px;
            background-color: ${ ({ theme }) => theme.colors.almostWhite };
            border-radius: 10px;
            padding: 4px 8px;
            font-size: 16px;

            .date, .seats-container {
              display: flex;
              gap: 4px;
              div {
                display: flex;
                align-items: center;
                gap: 4px;
              }
            }

            .bold {
              font-weight: 700 !important;
            }

            .tickets, .price {
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 4px;

              img {
                width: 22px;
                height: 22px;
              }
              span {
                font-weight: 600;
              }
            }
          }
        }

        .action-buttons {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          
          button {
            background: transparent;
            border: none;
          }
        }

      }

    }
  }

  .banner {
    height: 85px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 8px 20px;

    h4 {
      color: ${ ({ theme }) => theme.colors.white };
    }
    
    p {
      margin-bottom: 0px;
      color: ${ ({ theme }) => theme.colors.white };
      text-align: center;
    }
  }

  .cancelled-banner {
    background-color: ${ ({ theme }) => theme.colors.red }95;
  }

  .pending-payment-banner {
    background-color: ${ ({ theme }) => theme.colors.orangeDark }95;
  }

  .pending-refund-banner {
    background-color: ${ ({ theme }) => theme.colors.yellow }95;
  }

  .buttons-container {
    display: flex;
    flex-direction: row;
    gap: 8px;

    button {
      border: none;
      background: transparent;
      cursor: pointer;
      margin-left: auto;
    }
  }

  &.hide-map-mobile {
    @media screen and (max-width: 768px) {
      .map-container {
        display: none;
      }
    }
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    flex: 1;

    .details {
      flex: 1;
      display: flex;
      flex-direction: column;

      &-container {
        flex: 1;

        .spacer {
          display: block;
          flex: 1;
        }
      }
    }

    .map-container .map {
      margin-bottom: 8px !important;
    }

    .details {
      padding-top: 0;
      gap: 8px;

      .detail-row {
        padding: 8px 16px 0;
        width: calc(100% - 32px);

        .seats {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
      }

      .details-container {
        flex-direction: column;
        gap: 8px;
        padding-bottom: 28px;

        .info-wrapper {
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 16px;

          .information {
            flex-direction: column;

            .info-container {
              width: fit-content;
              
              &:first-of-type {
                align-items: flex-start;
                gap: 8px;
              }
            }
          }
        }
      }
    }
  }

  .seats-text {
    white-space: nowrap;
  }

  .price-mobile {
    display: none !important;
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .details .detail-row {
      padding: 16px;
      width: calc(100% - 32px);
    }
    .details .details-container {
      gap: 8px;
    }
    .seats-label {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    .price-mobile {
      display: flex !important;
    }
    .price-desktop, .tickets {
      display: none !important;
    }
    .info-container-tickets {
      display: none !important;
    }
  }

  @media screen and (max-width: 480px) {
    &.is-roundtrip .text-bottom {
      -webkit-line-clamp: 1;
    }

    &.is-roundtrip .aprox-prefix {
      display: none;
    }

    .seats-label {
      display: none;
    }
  }
`
